<template>
  <el-table-column
    prop="supplier.name"
    sortable="custom"
    label="Beszállító"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.supplier_name}}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'supplier.name',
};
</script>
